import React from 'react'

export default function InputText({id, label, value, placeholder, onChange, onBlur, onKeyDown, error, script, disabled, type, pattern}){
    return (
        <>
            <div className="font-semibold">
                {label && <label htmlFor={id}>{label}</label>}
            </div>
            <div className="mt-2">
                <input id={id} placeholder={placeholder} type={type} disabled={disabled} value={value} onChange={onChange} onBlur={onBlur} onKeyDown={onKeyDown} pattern={pattern} className={`w-full border border-gray-300 rounded-lg p-2 ${error ? 'border-red-700' : ''} focus:outline-none focus:border-primary focus:ring-primary focus:ring-1 rounded-md border border-gray-300 w-auto`} {...script} />
                <label className='text-red-700 italic'>{error}</label>
            </div>
        </>
    )
}